var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"dashboard-analytics"}},[_c('b-tabs',{attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":"コマンド集計","active":""}},[_c('Command')],1),_c('b-tab',{attrs:{"title":"ユーザー集計"}},[_c('User')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }